/**
 * Directories store.
 *
 */

import { Module, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import { tabsNav } from './tabs';
import PageEntity from '@/store/pageEntity';

export const MODULE_NAME = 'directories';

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class DirectoriesModule extends PageBaseModule {
    allTabs = tabsNav;
    tabsNav = {};

    constructor(module: DirectoriesModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle('');
        this.pageSettings = page.values;
        this.tabsNav = this.allTabs; //TODO:: need upd for roles
    }

}

export default getModule(DirectoriesModule);
